module.exports = __webpack_public_path__ + "static/media/FI.4c5194c2.svg";